import Vue from 'vue';
import './icons/buding-icons.less';
import App from './App.vue';
import './utils/axios';
import router from './router';
import global from './utils/global.js';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import {Message} from 'element-ui';
import './styles/theme.css';
import {initTheme} from './utils/theme';

/* 阻止VUE在启动时生成生产提示 */
Vue.config.productionTip = false;

/* 全局变量 */
Vue.prototype.$global = global;

/* 全局事件 */
Vue.prototype.$eventBus = new Vue();

/* ElementUI */
Vue.use(ElementUI);

/* ElementUI-消息 */
Vue.prototype.$message.info = function (msg) {
    return Message.info({message: msg, duration: 1000, offset: 6});
}
Vue.prototype.$message.success = function (msg) {
    return Message.success({message: msg, duration: 2000, offset: 6});
}
Vue.prototype.$message.warning = function (msg) {
    return Message.warning({message: msg, duration: 2000, offset: 6});
}
Vue.prototype.$message.error = function (msg) {
    return Message.error({message: msg, duration: 3000, offset: 6});
}

/* 定义通用按钮属性 */
Vue.mixin({
    computed: {
        // Home右上角按钮、Index快捷跳转按钮
        defaultBtn() {
            return {size: 'small', plain: true, style: {fontWeight: 'bold'}}
        },
        // 音乐播放器操作按钮
        mediumDefaultBtn() {
            return {size: 'medium', plain: true, style: {fontWeight: 'bold'}}
        },
        // 查询按钮
        primaryBtn() {
            return {type: 'primary', size: 'small', plain: true}
        },
        // 表单确认按钮
        mediumPrimaryBtn() {
            return {type: 'primary', size: 'medium', plain: true}
        },
        // 新增按钮
        successBtn() {
            return {type: 'success', size: 'small', plain: true}
        },
        // 清空按钮
        infoBtn() {
            return {type: 'info', size: 'small', plain: true}
        },
        // 表单取消按钮
        mediumInfoBtn() {
            return {type: 'info', size: 'medium', plain: true}
        },
        // 导出按钮、报表按钮
        warningBtn() {
            return {type: 'warning', size: 'small', plain: true}
        },
        dangerBtn() {
            return {type: 'danger', size: 'small', plain: true}
        },
        // 表格操作文字按钮
        textBtn() {
            return {type: 'text', size: 'small'}
        },
        mediumTextBtn() {
            return {type: 'text', size: 'medium'}
        }
    }
})

Vue.directive('default-select', {
    inserted(el) {
    }
});

initTheme();

new Vue({
    router,
    render: h => h(App),
    created() {
        console.log('欢迎使用：' + this.$global.systemName);
    },
}).$mount('#app')
